/* global angular */
( function () {
	'use strict';

	function pdfFeedbackFactory ( pdfCommon, api, $q ) {
		var feedbackObj = {};

		function returnEmptyArr () {
			return {
				'data' : {}
			};
		}

		function returnParams ( res ) {
			return res;
		}

		function requestFeedBackIds ( obsId ) {
			return api.feedback
				.get( obsId ).then( returnParams, returnEmptyArr );
		}

		function requestPosts ( data ) {
			return api.feedback.posts
				.get( data.observationId, data.feedbackId )
				.then( function ( res ) {
					feedbackObj[ data.observationId ] = data.feedbackId;
					return res;
				}, function () {
					return { 'data' : [] };
				} );
		}

		function requestUserDetails ( id ) {
			return api.userDetails( id );
		}

		function callPosts ( feedbackData ) {
			return $q.all( feedbackData.map( requestPosts ) );
		}

		function structureFeedbackData ( res ) {
			return res.map( function ( item ) {
				return {
					'observationId' : item.data.observationId,
					'feedbackId'    : item.data.feedbackId
				};
			} ).filter( function ( item ) {
				return item.observationId && item.feedbackId;
			} );
		}

		function callUserDetails ( postsData ) {
			var postsArr = [].concat.apply( [], pdfCommon.extractAttrToArr( postsData, 'data' ) );
			var uniqify  = pdfCommon.extractAttrToArr( postsArr, 'createdBy' )
				.reduce( function ( prev, cur ) {
					prev[ cur ] = 1;
					return prev;
				}, {} );

			return $q.all( Object.keys( uniqify ).map( requestUserDetails ) )
				.then( function ( res ) {
					postsArr.forEach( function ( item ) {
						item.creatorName = pdfCommon.extractAttrToArr( res, 'data' ).reduce( function ( prev, cur ) {
							var returnArr      = [ prev, cur.FirstName + ' ' + cur.LastName ];
							var conditionIndex = Number( String( cur.PersonnelId ) === String( item.createdBy ) );

							return returnArr[ conditionIndex ];
						}, '' );
					} );
					return postsArr;
				} );
		}

		function createCompleteFeedbackData ( postsArr ) {
			function filterFeedbackId ( key ) {
				return function ( item ) {
					return item.feedbackId === feedbackObj[ key ];
				};
			}

			return Object.keys( feedbackObj ).reduce( function ( prev, cur ) {
				prev[ cur ] = {
					'feedback' : postsArr.filter( filterFeedbackId( cur ) )
				};

				return prev;
			}, {} );
		}

		function attachFeedbackToObs ( obsData ) {
			return function ( feedbackData ) {
				obsData.forEach( function ( item ) {
					item.feedback = ( ( feedbackData[ item.id ] || {} ).feedback || [] ).sort( function ( a, b ) {
						return ( new Date( a.createdAt ).getTime() > new Date( b.createdAt ).getTime() ) && 1 || -1;
					} );
				} );
			};
		}

		function passthru ( obsData ) {
			obsData.forEach( function ( item ) {
				item.feedback = [];
			} );

			return $q.when( [] );
		}

		function cannAndAttachData () {
			return function ( obsData, obsIds ) {
				return $q.all( obsIds.map( requestFeedBackIds ) )
					.then( structureFeedbackData )
					.then( callPosts )
					.then( callUserDetails )
					.then( createCompleteFeedbackData )
					.then( attachFeedbackToObs( obsData ) );
			};
		}

		function attachToObs ( obsData, showOptions ) {
			var obsIds = pdfCommon.extractAttrToArr( obsData, 'id' );

			return [ Boolean( showOptions.Feedback ) ]
			.filter( Boolean )
			.reduce( cannAndAttachData, passthru )( obsData, obsIds );
		}

		return {
			'attachToObs' : attachToObs
		};
	}

	angular
		.module( 'app.components' )
		.factory( 'pdfFeedbackFactory', pdfFeedbackFactory );

	pdfFeedbackFactory.$inject = [ 'pdfCommonFactory', 'apiService', '$q' ];
} )();
